import { StytchB2BClient, createStytchB2BClient } from '@stytch/react/b2b'
import { isLocalAuthBypass, createLocalStytchStub } from './localAuth'

export const stytchClient: StytchB2BClient = isLocalAuthBypass()
  ? createLocalStytchStub({
      ssoTestConnectionId: import.meta.env.VITE_SSO_TEST_CONNECTION_ID
    })
  : createStytchB2BClient(import.meta.env.VITE_STYTCH_PUBLIC_TOKEN, {
      // Stytch takes the OAuth issuer from the domain it is called on. The MCP consent screen
      // (/oauth/authorize) submits through this client, so it must call the custom domain that the
      // authorization-server metadata advertises, or strict clients (ChatGPT) reject the `iss` on
      // the redirect. Unset falls back to Stytch's default domain.
      customBaseUrl: import.meta.env.VITE_STYTCH_CUSTOM_BASE_URL || undefined,
      cookieOptions: {
        jwtCookieName: import.meta.env.VITE_AUTH_SESSION_JWT_COOKIE_NAME,
        opaqueTokenCookieName: import.meta.env.VITE_AUTH_SESSION_COOKIE_NAME,
        domain: import.meta.env.VITE_AUTH_COOKIE_DOMAIN,
        availableToSubdomains: true,
        path: '/'
      }
    })

/**
 * Sometimes the Stytch Intermediate Session Token (IST) cookie isn't deleted after completing the org discovery auth flow.
 * Then the Stytch SDK tries to use the IST cookie instead of the Session cookie, resulting in errors.
 * So we should delete this cookie if the user is outside the auth flow.
 */
export function deleteIntermediateSessionTokenCookie() {
  if (isLocalAuthBypass()) return

  const domain = import.meta.env.VITE_AUTH_COOKIE_DOMAIN
  const expires = 'Thu, 01 Jan 1970 00:00:00 UTC'
  document.cookie = `stytch_intermediate_session_token=; Domain=.${domain}; Path=/; secure; SameSite=Lax; expires=${expires}`
}
